




































































































































































































































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { Data } from '@/modules/shared/models/data'
import QForm from 'quasar/src/components/form/QForm.js';import QLayout from 'quasar/src/components/layout/QLayout.js';
import dayjs from 'dayjs'
import WarningConfirm from '@/modules/common/dialog/components/shared/WarningConfirmOld.vue'
import Tooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import PanelUploader from '@/modules/media/components/shared/PanelUploader.vue'
import { WriterRoutes } from '@/modules/shared/routes/writer'

@Component({
  components: {
    PanelUploader,
    Heading,
    BaseInput,
    DateTooltipped,
    BaseButton,
    Tooltip,
    WarningConfirm
  }
})
export default class ShowTicketPage extends Vue {
  constructor(
    private readonly useCase: TicketUsecase,
    private readonly routes: WriterRoutes
  ) {
    super()
  }

  @Prop() ticket !: Data<Ticket>

  drawer = false

  miniState = true

  closeTicket = false

  openTicket = false

  message = ''

  attachments = []

  $refs!: {
    answer: QForm,
    layout: QLayout
  }

  mounted() {
    setTimeout(() => {
      let layout = this.$el.querySelector('.scroll')
      layout.scrollTop = layout.scrollHeight
    })
  }

  toOffsetDate(isoString) {
    return dayjs(isoString).fromNow()
  }

  drawerClick(e) {
    if (this.miniState) {
      this.miniState = false
      e.stopPropagation()
    }
  }

  isAnswerMine(answer: Answer) {
    return answer.user.id === this.ticket.data.user.id
  }


  get answers() {
    return this.ticket.data.answers.reverse()
  }

  async sendAnswer() {
    let ok = false

    ok = await this.$refs.answer.validate()

    if (!ok) return

    this.useCase.newAnswer(
      this.ticket.data.id,
      { message: this.message, file: this.attachments }
    )
  }

}
